import React, { useMemo, useState } from "react";
import cn from "classnames";
import FullWidthModal from "../../components/common/Modal/FullWidthModal";
import ModalHeader from "../../components/common/ModalHeader/index";
import { TouchableButton } from "../../components/common/Touchable/index";
import { ReactComponent as TipCheckMark } from '@assets/images/tipCheckMark.svg';
import { toWords } from "number-to-words";
import { safeJsonParse } from '@utility/helperFunction';
import { CUSTOM_MESSAGES, LABEL } from "../../veriables";


const AdavancrTipConfirmationPopup = (props) => {
  const {
    isOpen,
    onClose,
    onSubmitTips,
    serverAppTheme,
    tipAmount,
    totalAmountForTip,
    isLandScape,
    // seat,
    // supportsWarnOnUnusualTip,
    // isCounter,
  } = props;

  const seat = safeJsonParse(window.sessionStorage.getItem('seat'), {});

  const checkDecimal = (val) => {
    const newValdata = val.toString().split(".");
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0, 1);
      if (Number(newstr) > 0) {
        return Number(val)?.toFixed(1);
      } else {
        return newValdata[0];
      }
    }
    return val;
  };

  const tipPercents = checkDecimal(
    ((Number(tipAmount) / (totalAmountForTip || 1)) * 100)?.toFixed(1)
  )

  function formatAmount(amount) {
    if (amount == null || isNaN(amount)) return "";

    const fixedAmount = Number(amount).toFixed(2);
    const [dollars, cents] = fixedAmount.split(".");

    const dollarWords = titleCase(toWords(Number(dollars)));
    const centWords =
      cents === "00"
        ? "Zero"
        : titleCase(toWords(Number(cents)));

    return `${dollarWords} Dollars and ${centWords} Cents`;
  }

  function titleCase(str) {
    return str
      .split(" ")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  const popUpModal = useMemo(() => {
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: "#ffff",
      border: "none",
      borderRadius: "8px",
    };

    return { okButton };
  }, [serverAppTheme]);

  const formattedTipAmount = tipAmount
    ? Number(tipAmount)?.toFixed(2)
    : "0.00";

  const tipOptions = [
    {
      id: "KEEP",
      label: `I want to leave a Tip of $${formattedTipAmount} (${formatAmount(tipAmount)}) which is ${tipPercents}%.`,
      route: onSubmitTips,
    },
    {
      id: "CHANGE",
      label: "I want to change my Tip and enter a different amount.",
      route: () => onClose(false),
    },
  ];

  const [selectedOption, setSelectedOption] = useState("");

  const handleContinue = () => {
    const selected = tipOptions.find((item) => item.id === selectedOption);

    if (!selected) return;

    selected.route();
  };

  return (
    <FullWidthModal
      isOpen={isOpen}
      customClass2={cn("w-100 h-100 position-relative")}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        pointerEvents: "auto",
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: "padding-box",
        border: "0",
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            "col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100",
          )}
        >
          {/* 1. header */}
          <ModalHeader
            stationName={seat?.stationName}
            tileHeader="Tip"
            seatNumber={seat?.number}
            isTipWarning={true}
          />
          {/* 2. selection part */}
          <div className={cn(isLandScape ? "col-8 m-auto align-items-center d-flex fs_24 fw-600 h-85 text-center" : "align-items-center d-flex fs_24 fw-600 h-85 text-center")}>
            <div className="col-12">
              <div className="fs_24 fw-600 pb-24">{CUSTOM_MESSAGES().PLEASE_MAKE_SELECTION_AND_CONTINUE}</div>
              <div>
                {tipOptions.map((item) => (
                  <div
                    key={item.id}
                    className={cn("d-flex fs_16 fw-400 p-3 mb-3")}
                    style={{
                      borderRadius: "8px",
                      border: selectedOption === item.id ? "1px solid #253382" : "1px solid #D5D5D5",
                      background: "#FFF",
                    }}
                    onClick={() => setSelectedOption(item.id)}
                  >
                    <div className="w-90 text-left">
                      {item.label}
                    </div>
                    {selectedOption === item.id && (
                      <div className="align-items-center d-flex justify-content-around w-10">
                        <TipCheckMark className="h-100" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* 3. button */}
          <div
            className={cn(
              'col-12 d-flex justify-content-center position-absolute pb-3',
            )}
            style={{ bottom: '0' }}
          >
            <div className={cn(isLandScape ? "col-4 pl-1 pr-0" : "col-6 pl-1 pr-0")}>
              <TouchableButton
                type="submit"
                className={cn(
                  selectedOption ? 'od-primary-btn-bg-color od-primary-btn-font-color' : 'od-disable-btn-bg-color od-disable-btn-font-color',
                  isLandScape ? 
                  "col-12 btn-ripple btn-lg btn44" 
                  : 'col-12 btn-ripple btn-lg btn68'
                )}
                style={{
                  background: !selectedOption ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleContinue();
                }}
                disabled={!selectedOption}
                rippleEffect={true}
              >
                <div className={cn('fs_28 fw-600')}>
                  {LABEL().TIPS_CONTINUE}
                </div>
              </TouchableButton>
            </div>
          </div>
        </div>
      </div>
    </FullWidthModal >
  )
}

export default AdavancrTipConfirmationPopup